<div
  class="nav-sidebar-upgrade-banner"
  *ngIf="(isTrialEligibleGuestUser$ | async) || (isTrialInstitutionAdmin$ | async)"
>
  <div class="nav-sidebar-upgrade-banner__content">
    <ng-container *ngIf="isTrialEligibleGuestUser$ | async; else trialEndTemplate">
      <div class="nav-sidebar-upgrade-banner__copy">
        <p class="nav-sidebar-upgrade-banner__title">
          {{ 'Level up your teaching' | translate }}
        </p>
        <p class="nav-sidebar-upgrade-banner__description">
          {{ 'Video calling, recording, AI and more - free for 14 days.' | translate }}
        </p>
      </div>

      <app-pencil-button
        class="nav-sidebar-upgrade-banner__button"
        [theme]="PencilButtonThemeEnum.SECONDARY_OUTLINE"
        [icon]="'noto_rocket'"
        [iconConfig]="{ type: IconTypes.svgIcon }"
        [label]="'Start free trial' | translate"
        (clickEvent)="startFreeTrial()"
        data-name="nav-sidebar-upgrade-banner-start-free-trial"
      ></app-pencil-button>
    </ng-container>
  </div>
</div>

<ng-template #trialEndTemplate>
  <div class="nav-sidebar-upgrade-banner__copy">
    <p
      *ngIf="nextBillingDate$ | async as nextBillingDate"
      class="nav-sidebar-upgrade-banner__title"
    >
      {{ nextBillingDate | trialEndsTranslation }}
    </p>
    <p class="nav-sidebar-upgrade-banner__description">
      {{ 'Upgrade to keep using the Pencil Spaces classroom.' | translate }}
    </p>
  </div>
  <app-pencil-button
    class="nav-sidebar-upgrade-banner__button"
    [theme]="PencilButtonThemeEnum.SECONDARY_OUTLINE"
    icon="arrow_circle_up"
    [iconConfig]="{ type: IconTypes.materialIcon }"
    [label]="'Upgrade' | translate"
    (clickEvent)="openPaymentSettings()"
    data-name="nav-sidebar-upgrade-banner-upgrade"
  ></app-pencil-button>
</ng-template>
